<template>
  <NuxtImg
    data-testid="nuxtTransformImageTestid"
    :class="class"
    :loading="loading"
    :src="src"
    :sizes="sizes"
    :alt="alt"
    :title="title"
    :format="computedFormat"
    :width="width"
    :height="height"
    :quality="quality"
    :is-map="false"
    :decoding="'auto'"
    @click="sendTrackingEvent()"
  />
</template>

<script lang="ts" setup>
import { sendButtonClickedEvent } from '@/resources/tracking';

interface Props {
  src: string;
  class?: string;
  loading?: 'lazy' | 'eager';
  alt?: string;
  title?: string;
  width?: string;
  height?: string;
  quality?: string;
  sizes?: string;
  format?: string;
  trackingOptions?: object;
  id?: string;
  label?: string;
}

const props = withDefaults(defineProps<Props>(), {
  src: '',
  loading: 'lazy',
  class: undefined,
  alt: undefined,
  title: undefined,
  width: undefined,
  height: undefined,
  sizes: undefined,
  quality: '70',
  format: 'webp',
  id: undefined,
  label: undefined
});

const computedFormat = computed(() => (props.src?.endsWith('.svg') ? 'svg' : props.format));

function sendTrackingEvent() {
  sendButtonClickedEvent({
    targetUrl: props.trackingOptions?.targetUrl,
    targetPath: props.trackingOptions?.targetPath,
    label: props.trackingOptions?.label || 'no label',
    citySelected: props.trackingOptions?.citySelected || 'no info',
    listId: ['no info'],
    category: props.trackingOptions?.category || ['no info'],
    elementId: props.trackingOptions?.elementId || 'no info',
    hostId: props.trackingOptions?.hostId || 'no info',
    locationCity: [props.trackingOptions?.locationCity] || ['no info'],
    motivLevel: [props.trackingOptions?.locationCity] || ['no info'],
    dateSelected: props.trackingOptions?.dateSelected,
    itemName: props.trackingOptions?.itemName || 'no info',
    buttonAction: props.trackingOptions?.buttonAction || 'link',
    value: props.trackingOptions?.value || 'no value'
  });
}
</script>
